import { html, LitElement, TemplateResult } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';

type Direction = 'left' | 'right';

@customElement('marquee-redux')
export class MarqueeRedux extends LitElement {

	// Props

	@property({ type: String })
	duration: string = '100s';

	@property({ type: String })
	space: string = '10px';

	@property({ type: String })
	direction: Direction = 'left';

	@state()
	_messages: string[] = [];

	@query('.Marquee-container')
	_container: HTMLElement;

	@query('.Marquee-element')
	_element: HTMLElement;

	// Lifecycle Hooks

	firstUpdated() {

		// add classes
		this.classList.add('Marquee');

		// slots
		const slots = [...this.querySelectorAll('[slot="message"]')] as HTMLElement[];
		this._messages = slots.map((slot) => slot.innerText);
		slots.forEach((slot) => slot.remove());

		requestAnimationFrame(() => {
			this.setup();
		});
	}

	// Render

	render() {
		return html`
			<div class="Marquee-wrapper">
				<div class="Marquee-container">
					<div class="Marquee-element">
						${ this._messages.map((message) => this.messageTemplate(message)) }
					</div>
				</div>
			</div>
		`;
	}

	createRenderRoot() { 
		return this;
	}

	// Templates
	
	messageTemplate(message: string): TemplateResult {
		return html`
			<span class="Marquee-message">${ message }</span>
		`;
	}

	// Methods

	setup() {
		const bbox = this._element.getBoundingClientRect();
		const elementWidth = bbox.right - bbox.left;
		const numCopies = Math.ceil(screen.width / elementWidth) * 2;
		const totalWidth = numCopies * elementWidth;
		this._container?.style.setProperty('--total-width', `${totalWidth}px`);
		for (let i = 1; i < numCopies; i++) {
            const clone = this._element.cloneNode(true);
            this._container.appendChild(clone);
        }
	}

}